import React, { useState, useEffect } from "react";
import axios from "axios";
import logo from "../assets/images/krishnasilver.png";
import { Link, useLocation } from "react-router-dom";

const Header = () => {

    const [categories, setCategories] = useState([]);
    const [scrolled, setScrolled] = useState(false);
    const [mobileDropdown, setMobileDropdown] = useState(false);
    const [contactInfo, setContactInfo] = useState({});

    const location = useLocation();

    /* ========================
    SCROLL DETECT
    ======================== */

    useEffect(() => {

        const handleScroll = () => {
            if (window.scrollY > 60) {
                setScrolled(true);
            } else {
                setScrolled(false);
            }
        };

        window.addEventListener("scroll", handleScroll);

        return () => window.removeEventListener("scroll", handleScroll);

    }, []);


    /* ========================
    BODY PADDING FIX
    ======================== */

    // useEffect(() => {

    //     const updatePadding = () => {
    //         const header = document.querySelector("header");

    //         if (header) {
    //             document.body.style.paddingTop = header.offsetHeight + "px";
    //         }
    //     };

    //     updatePadding();
    //     window.addEventListener("resize", updatePadding);

    //     return () => window.removeEventListener("resize", updatePadding);

    // }, []);

    useEffect(() => {

        const updatePadding = () => {

            const header = document.querySelector("header");

            if (header) {
                document.body.style.paddingTop = header.offsetHeight + "px";
            }

        };

        updatePadding();

        window.addEventListener("resize", updatePadding);
        window.addEventListener("scroll", updatePadding);

        return () => {
            window.removeEventListener("resize", updatePadding);
            window.removeEventListener("scroll", updatePadding);
        };

    }, []);


    /* ========================
    FETCH CATEGORIES
    ======================== */

    useEffect(() => {

        axios
            .get("https://kskrishnasilver.com/api/category.php")
            .then((res) => {

                if (Array.isArray(res.data)) {
                    setCategories(res.data);
                } else if (res.data.data) {
                    setCategories(res.data.data);
                }

            })
            .catch((err) => console.log(err));

    }, []);


    /* ========================
    FETCH CONTACT
    ======================== */

    useEffect(() => {

        axios
            .get("https://kskrishnasilver.com/api/contact.php")
            .then((res) => {
                setContactInfo(res.data);
            })
            .catch((err) => console.log(err));

    }, []);


    /* ========================
    CLOSE DROPDOWN ON ROUTE CHANGE
    ======================== */

    useEffect(() => {
        setMobileDropdown(false);
    }, [location.pathname]);


    /* ========================
    CLOSE MOBILE NAVBAR
    ======================== */

    const closeNavbar = () => {

        const navbar = document.querySelector(".navbar-collapse");

        if (navbar?.classList.contains("show")) {
            const bsCollapse = new window.bootstrap.Collapse(navbar, {
                toggle: false,
            });

            bsCollapse.hide();
        }

    };


    return (

        <header className={`header ${scrolled ? "scrolled" : ""}`}>

            {/* ================= TOPBAR ================= */}

            <div className="topbar">

                <div className="container topbar-container">

                    <div className="topbar-left">

                        <span>
                            <i className="fa-solid fa-phone"></i>
                            <Link to={`tel:+91${contactInfo.mobile}`}>
                                +91 {contactInfo.mobile}
                            </Link>
                        </span>

                        <span>
                            <i className="fa-solid fa-envelope"></i>
                            <Link to={`mailto:${contactInfo.email}`}>
                                {contactInfo.email}
                            </Link>
                        </span>

                        <span>
                            <i className="fa-solid fa-location-dot"></i>
                            <Link to={contactInfo.map_link} target="_blank">
                                {contactInfo.address}
                            </Link>
                        </span>

                    </div>

                    <div className="topbar-right">

                        <Link
                            to="https://www.facebook.com/profile.php?id=100025439691121"
                            target="_blank"
                        >
                            <i className="fa-brands fa-facebook-f"></i>
                        </Link>

                        <Link
                            to="https://www.instagram.com/krishna_silver_rajkot/"
                            target="_blank"
                        >
                            <i className="fa-brands fa-instagram"></i>
                        </Link>

                    </div>

                </div>

            </div>


            {/* ================= NAVBAR ================= */}

            <nav className="navbar navbar-expand-lg bg-body-tertiary">

                <div className="container">

                    <Link to="/" className="logo" onClick={closeNavbar}>
                        <img src={logo} className="logo-img" alt="logo" />
                    </Link>


                    <button
                        className="navbar-toggler"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#navbarNavDropdown"
                    >
                        <span className="navbar-toggler-icon"></span>
                    </button>


                    <div className="collapse navbar-collapse" id="navbarNavDropdown">

                        <ul className="navbar-nav ms-auto">

                            {/* HOME */}
                            <li className="nav-item">
                                <Link
                                    className={`nav-link ${location.pathname === "/" ? "active" : ""}`}
                                    to="/"
                                    onClick={closeNavbar}
                                >
                                    HOME
                                </Link>
                            </li>


                            {/* ABOUT */}
                            <li className="nav-item">
                                <Link
                                    className={`nav-link ${location.pathname === "/about" ? "active" : ""}`}
                                    to="/about"
                                    onClick={closeNavbar}
                                >
                                    ABOUT US
                                </Link>
                            </li>


                            {/* COLLECTION DROPDOWN */}

                            <li
                                className="nav-item dropdown custom-dropdown"
                                onMouseEnter={() =>
                                    window.innerWidth > 768 && setMobileDropdown(true)
                                }
                                onMouseLeave={() =>
                                    window.innerWidth > 768 && setMobileDropdown(false)
                                }
                            >

                                <div className="nav-link-wrapper">

                                    <Link
                                        to="/collections"
                                        className={`nav-link ${location.pathname.startsWith("/collection") ||
                                            location.pathname === "/collections"
                                            ? "active"
                                            : ""
                                            }`}
                                        onClick={closeNavbar}
                                    >
                                        OUR COLLECTIONS
                                    </Link>


                                    <span
                                        className="dropdown-arrow"
                                        onClick={() => setMobileDropdown(!mobileDropdown)}
                                    >
                                        <i className="fa-solid fa-chevron-down"></i>
                                    </span>

                                </div>


                                <ul className={`dropdown-menu ${mobileDropdown ? "show" : ""}`}>

                                    {categories.map((cat, index) => (

                                        <li key={index}>

                                            <Link
                                                className={`dropdown-item ${location.pathname === `/collection/${cat.slug}`
                                                    ? "active"
                                                    : ""
                                                    }`}
                                                to={`/collection/${cat.slug}`}
                                                onClick={closeNavbar}
                                            >
                                                {cat.name}
                                            </Link>

                                        </li>

                                    ))}

                                </ul>

                            </li>


                            {/* CONTACT */}
                            <li className="nav-item">
                                <Link
                                    className={`nav-link ${location.pathname === "/contact-us" ? "active" : ""
                                        }`}
                                    to="/contact-us"
                                    onClick={closeNavbar}
                                >
                                    CONTACT US
                                </Link>
                            </li>

                        </ul>

                    </div>

                </div>

            </nav>

        </header>

    );
};

export default Header;